import { ReactNode } from "react";
import "./block-title.sass";

type Props = {
  children: ReactNode;
};

const BlockTitle = ({ children }: Props) => {
  return <div className="block-title">{children}</div>;
};

export default BlockTitle;
